import { css } from '@/styled-system/css';

export const contentWrapperStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  textAlign: 'center',
  padding: 'loose',
  paddingTop: 0,
});

export const iconCommentInverseStyles = css.raw({
  transform: 'scaleX(-1)',
  position: 'relative',
  bottom: '500',
  display: 'inline-block',
});
